export default "__VITE_ASSET__C5TzI6hx__"